<template>
  <div class="eaAreaSurveyTemporary">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>
        <!-- 物业区域概况 -->
         用户报修概况
      </span>
      <!-- <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span> -->
    </div>
    <div class="container">
      <div class="box">
        <div class="AreaSurvey">

          <div class="charts">
            <div  ref="eaarea" style="width:400px;height:250px"></div>
            <!-- <div
              @click="forwordtoQueryOrganMge(3,2)" forwordtoQueryOrganMge(2,1)
              ref="generalMeeting"
              style="width:210px;height:150px"
            ></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HomeControllerSvr } from '@/service/HomeControllerSvr';
import { HomePageExControllerSvr } from '@/service/HomePageExControllerSvr';
import { mapState } from 'vuex';

export default {
  components: {},
  props: { myprop: Boolean },
  data() {
    return {
      dataArray: [],
      areaProtoy: {}
    };
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    this.HomePageExControllerSvr = new HomePageExControllerSvr()
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.HomePageExControllerSvr.GetRepairSituation(this.token).then(res => {
        for ( const {RepairNum: repairNum, RepairNumRate: repairNumRate, CantonNmae: cantonNmae, OverRepairNum: overRepairNum} of res) {
           this.dataArray.push({
             value: repairNum,
             name: cantonNmae,
             percentage: repairNumRate,
             overRepairNum: overRepairNum
           })
        }
        this.drawVote(this.$refs.eaarea, '已处理的投诉', this.dataArray, '#ffb11a');
      });
    },
    forwordtoQueryOrganMge(value, type) {
      this.$router.push({
        path: 'queryOrganMge',
        query: {
          children: value,
          paramType: type
        }
      });
    },
    forwordAlltoarea() {
      this.$router.push({
        path: 'queryPropertyArea'
      });
    },
    forwordtoarea() {
      this.$router.push({
        path: 'queryPropertyArea',
        query: {
          option: 2
        }
      });
    },
    jumpMore() {
      this.$router.push({ path: 'queryPropertyArea' });
    },
    drawVote(dom, name, data, color, option) {
      //投诉统计
      let myChartSatisfaction = this.$echarts.init(dom);
      let partNum = 0;
      // info.CandidateItems._Items.forEach(item => {
      //   partNum += 1;
      // });
      //let percentage = Math.round(partNum / totlNum * 100) + '%';
      let percentage;
      if (parseInt(data[1]) >= 0 && parseInt(data[0]) >= 0) {
        if (parseInt(data[0]) === 0) {
          percentage = '0%';
        } else {
          percentage =
            (parseInt(data[1]) / parseInt(data[0]) * 100).toFixed(0) + '%';
        }
      } else {
        percentage = '0%';
      }

      //如果大于0不到1%的显示<1%
      if (
        parseInt(data[1]) / parseInt(data[0]) * 100 > 0 &&
        parseInt(data[1]) / parseInt(data[0]) * 100 < 1
      ) {
        percentage = '<'+'1%';
      }
      myChartSatisfaction.setOption({
        tooltip : {
            trigger: 'item',
            formatter: function (params, ticket, callback) { 
              return `${params.seriesName} <br/>全市比例:${params.name} : ${params.value} (${params.percent}%) <br/>实收比例:${params.data.overRepairNum} (${params.data.percentage}%) `
          }
        },
        // toolbox: {
        //     show : true,
        //     feature : {
        //         mark : {show: true},
        //         dataView : {show: true, readOnly: false},
        //         magicType : {
        //             show: true,
        //             type: ['pie', 'funnel']
        //         },
        //         restore : {show: true},
        //         saveAsImage : {show: true}
        //     }
        // },
        calculable : true,
        series : [
            {
                name:'半径模式',
                type:'pie',
                radius : [20, 110],
                center : ['50%', '50%'],
                roseType : 'radius',
                label: {
                    normal: {
                        show: false
                    },
                    emphasis: {
                        show: true
                    }
                },
                lableLine: {
                    normal: {
                        show: false
                    },
                    emphasis: {
                        show: true
                    }
                },

            },
            {
                name:'报修情况',
                type:'pie',
                radius : [20, 100],
                center : ['50%', '50%'],
                roseType : 'area',
                data: data
                // [
                //     {value:335, name:'九里区',percentage: 20,},
                //     {value:310, name:'泉山区',percentage: 20},
                //     {value:274, name:'贾汪区',percentage: 20},
                //     {value:235, name:'云龙区',percentage: 20},
                //     {value:400, name:'鼓楼区',percentage: 20},
                //     {value:335, name:'新沂市',percentage: 20},
                //     {value:310, name:'邳州市',percentage: 20},
                //     {value:274, name:'睢宁县',percentage: 20},
                //     {value:235, name:'铜山县',percentage: 20},
                //     {value:235, name:'沛县',percentage: 20},                    
                //     {value:400, name:'丰县',percentage: 20}
                // ]
            }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.eaAreaSurveyTemporary {
  background: #fff;
  .container {
    height: 260px;
    .box {
      width: 100%;
      height: 100%;
      overflow: hidden;
      .AreaSurvey {
        display: flex;
        justify-content: center;
        .title {
          position: relative;
          padding-left: 15px;
          font-size: 14px;
          &::after {
            position: absolute;
            left: 8px;
            top: 2px;
            content: '';
            width: 4px;
            height: 10px;
            background: #0f77f2;
          }
        }
        .info-text {
          display: flex;
          .info-first,
          .info-second {
            .text {
              margin-top: 10px;
              padding-left: 8px;
              padding-right: 2px;
              font-size: 12px;
              line-height: 14px;
              .num {
                font-size: 13px;
                font-weight: bold;
                color: #0f77f2;
                float: right;
                &.warn {
                  color: #ff4546;
                }
              }
              .cursor {
                cursor: pointer;
              }
            }
          }
          .info-first {
            width: 46%;
            .text {
              border-right: 1px solid #afafaf;
            }
          }
          .info-second {
            width: 54%;
            .text {
              padding-left: 8px;
              text-align: center
            }
          }
        }

        .charts {
          display: flex;
          justify-content: center;
          .typeTitle {
            margin-top: 16px;
            display: flex;
            flex-direction: row;
            min-width: 200px;
            justify-content: space-around;
            .fontSize {
              display: block;
              height: 14px;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: -1px;
              color: #333333;
            }
            .num {
              margin-top: 6px;
              display: block;
              text-align: center;
              margin-right: 3px;
              &.warn {
                color: #ff4546;
              }
            }
          }
        }
        .compared {
          height: 230px;
          padding: 10px;
          .chartBox {
            // border-top: 1px solid #e2e2e2;
            padding-top: 10px;
            .tableInfo {
              margin-top: 12px;
              padding-left: 10px;
              display: flex;
              font-size: 12px;
              color: #333;
              .num {
                font-weight: bold;
              }
            }
          }
        }
      }
      .line {
        width: 1px;
        height: 100%;
        background: #e2e2e2;
      }
    }
  }
}
</style>